import { uri } from '../../api-endpoint';
import { IAnnotationFromAPISuccessResponse } from '../../type-conversion/annotation/from-api-repsonse';
import { fetchListTemplateFn } from '../common';

export const fetchModelImageAnnotationListAPI = (token: string) => (
  modelId: number,
  imageId: number
) =>
  fetchListTemplateFn(
    token,
    uri.modelImageAnnotationList(modelId, imageId),
    IAnnotationFromAPISuccessResponse
  );
